// Components/ui
import { Box, Typography, styled } from '@mui/material';

export const StyledDatePickerContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 0.5,
})) as typeof Box;
export const StyledPickersContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'baseline',
  gap: 1,
})) as typeof Box;
export const StyledPickersDivider = styled(Typography)(() => ({
  marginX: '8px',
  marginTop: '-15px',
  color: 'text.primary',
})) as typeof Typography;
